import QuestionPoolNavigator from "pages/ManagementPage/questionSection/QuestionPoolNavigator/QuestionPoolNavigator";

export default QuestionPoolNavigator;
